//region :: Imports ::
import {MColor} from './Utils';

//endregion

/** */
export type MIcon = { name: string, color: MColor };

/** */
export const MNewIconName = 'pi pi-plus';
export const MAddIconName = 'pi pi-plus';
export const MOpenIconName = 'pi pi-folder-open';
export const MSaveIconName = 'pi pi-save';
export const MDeleteIconName = 'pi pi-trash';
export const MRefreshIconName = 'pi pi-refresh';
export const MCopyIconName = 'pi pi-copy';
export const MCloseIconName = 'pi pi-times';
export const MBackIconName = 'pi pi-arrow-left';
export const MSearchIconName = 'pi pi-search';
export const MNavigateToIconName = 'pi pi-arrow-circle-right';
export const MLoginIconName = 'pi pi-sign-in';
export const MLogoutIconName = 'pi pi-sign-out';
export const HomeIconName = 'pi pi-home';

export const MSuccessIconName = 'pi pi-check-circle';
export const MInfoIconName = 'pi pi-info-circle';
export const MWarningIconName = 'pi pi-exclamation-circle';
export const MErrorIconName = 'pi pi-times-circle';

export const MOkIconName = 'pi pi-check';
export const MCancelIconName = 'pi pi-times';
export const MYesIconName = 'pi pi-check';
export const MNoIconName = 'pi pi-times';
export const MAllowIconName = 'pi pi-check';
export const MDenyIconName = 'pi pi-ban';

export const MLightThemeIconName = 'pi pi-sun';
export const MDarkThemeIconName = 'pi pi-moon';

/** */
export const MSuccessIcon: MIcon = {name: MSuccessIconName, color: 'mcolor-success'};
export const MInfoIcon: MIcon = {name: MInfoIconName, color: 'mcolor-info'};
export const MWarningIcon: MIcon = {name: MWarningIconName, color: 'mcolor-warning'};
export const MErrorIcon: MIcon = {name: MErrorIconName, color: 'mcolor-danger'};
